'use client'

import { createContext, useContext, useMemo, useReducer, useRef } from 'react'

const ActionKind = {
  SET_META: 'SET_META',
  PLAY: 'PLAY',
  PAUSE: 'PAUSE',
  TOGGLE_MUTE: 'TOGGLE_MUTE',
  SET_CURRENT_TIME: 'SET_CURRENT_TIME',
  SET_DURATION: 'SET_DURATION',
  SET_EPISODES: 'SET_EPISODES',
  SET_CURRENT_EPISODE_INDEX: 'SET_CURRENT_EPISODE_INDEX',
}

const AudioPlayerContext = createContext(null)

function audioReducer(state, action) {
  switch (action.type) {
    case ActionKind.SET_META:
      return { ...state, episode: action.payload }
    case ActionKind.PLAY:
      return { ...state, playing: true }
    case ActionKind.PAUSE:
      return { ...state, playing: false }
    case ActionKind.TOGGLE_MUTE:
      return { ...state, muted: !state.muted }
    case ActionKind.SET_CURRENT_TIME:
      return { ...state, currentTime: action.payload }
    case ActionKind.SET_DURATION:
      return { ...state, duration: action.payload }
    case ActionKind.SET_EPISODES:
      return { ...state, episodes: action.payload }
    case ActionKind.SET_CURRENT_EPISODE_INDEX:
      return { ...state, currentEpisodeIndex: action.payload }
    default:
      return state
  }
}

export function AudioProvider({
  children,
  initialEpisodes = [
    {
      id: 1,
      title: 'Lovely Design (Violet Warren)',
      published: 1645660800000,
      description: '12th Grade, Twin Peaks Classical Academy',
      enclosures: [
        {
          url: 'https://dev-st-vrain-valley-schools.pantheonsite.io/wp-content/uploads/2025/01/Lovely-Design-VW.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://dev-st-vrain-valley-schools.pantheonsite.io/wp-content/uploads/2025/01/Lovely-Design-VW.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 2,
      title: 'Untitled (Luis Macías)',
      published: 1645660800000,
      description: '2024 Graduate, Longmont High School',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-LM.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-LM.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 3,
      title: 'Dysfunctional (Daisy ‘Ollie’ O’Brien)',
      published: 1645660800000,
      description: '11th Grade, Niwot High School',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Dysfunctional-DO.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Dysfunctional-DO.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 4,
      title: 'Undermined (Shiloh Warren)',
      published: 1645660800000,
      description: '12th Grade, Twin Peaks Classical Academy',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Undermined-SW.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Undermined-SW.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 5,
      title: 'Constant (Samara McDermid)',
      published: 1645660800000,
      description: '10th Grade, Niwot High School',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Constant-SM.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Constant-SM.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 6,
      title: 'Untitled (Eric Brunsman)',
      published: 1645660800000,
      description: '10th Grade, Frederick High School',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-EB.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-EB.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 7,
      title: 'Apollo (Izak ‘Hazel’ Blue)',
      published: 1645660800000,
      description: '8th Grade, Homeschool',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Apollo-IB1.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Apollo-IB1.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 8,
      title:
        'Self Love Vacation (Elizabeth ‘Ellie’ Eckstine and Olive ‘Ollie’ McElroy)',
      published: 1645660800000,
      description: 'Ellie: 9th Grade, APEX, Ollie: 8th Grade, Flagstaff',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Self-Love-Vacation-Audio-Only.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Self-Love-Vacation-Audio-Only.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 9,
      title: 'Untitled (Matthew Schwartz)',
      published: 1645660800000,
      description: '8th Grade, Altona Middle School',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-MS.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-MS.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 10,
      title: 'Through the Deep (Charlotte Castaneda)',
      published: 1645660800000,
      description: '9th Grade, Niwot High School',
      enclosures: [
        {
          url: 'test',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'test',
        type: 'audio/mpeg',
      },
    },
    {
      id: 11,
      title: 'Untitled (Ashby Goodwin)',
      published: 1645660800000,
      description: '7th Grade, Stargate School',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-AG.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-AG.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 12,
      title: 'Drone Show Render (Emily Whiteley and Tyler Detro)',
      published: 1645660800000,
      description:
        'Emily Whiteley: 11th Grade, Erie High School, Tyler Detro: 12th Grade, Erie High School',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Butterfly-Drone-Show.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Butterfly-Drone-Show.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 13,
      title: 'He is Watching (Jack O’Toole)',
      published: 1645660800000,
      description: '8th Grade, Altona Middle School',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/He-is-Watching-Jack-O_Toole.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/He-is-Watching-Jack-O_Toole.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 14,
      title:
        'Pong Theme Song (Ivan Chang, Arnav Thakar, Cary Peterson, Evrim Birsoy)',
      published: 1645660800000,
      description:
        'Ivan Chang: 8th Grade, Altona Middle School, Arnav Thakar: 7th Grade, Altona Middle School, Cary Peterson: 7th Grade, Flagstaff Middle School, Evrim Birsoy: 7th Grade, Flagstaff Middle School',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Pong-Theme-Song.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Pong-Theme-Song.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 15,
      title: 'Untitled (Forest Hightower)',
      published: 1645660800000,
      description: '5th Grade, Centennial Elementary School',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-FH.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-FH.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 16,
      title: 'Untitled (Emma Marcenco)',
      published: 1645660800000,
      description: '4th Grade, Soaring Heights Elementary School',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-EM.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-EM.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 17,
      title: 'Untitled (Malia Martinez)',
      published: 1645660800000,
      description: '5th Grade, Mead Elementary School',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-MM.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-MM.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 18,
      title: 'Untitled (Elijah Margheim)',
      published: 1645660800000,
      description: '5th Grade, Firestone Charter',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-ElM-.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-ElM-.mp3',
        type: 'audio/mpeg',
      },
    },
    {
      id: 19,
      title: 'Untitled (Maxwell Zaun)',
      published: 1645660800000,
      description: '4th Grade, Red Hawk Elementary School',
      enclosures: [
        {
          url: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-MZ.mp3',
          type: 'audio/mpeg',
        },
      ],
      audio: {
        src: 'https://www.svvsd.org/wp-content/uploads/2025/01/Untitled-MZ.mp3',
        type: 'audio/mpeg',
      },
    },
  ],
}) {
  const initialState = {
    playing: false,
    muted: false,
    duration: 0,
    currentTime: 0,
    episode: null,
    episodes: initialEpisodes,
    currentEpisodeIndex: 0,
  }

  const [state, dispatch] = useReducer(audioReducer, initialState)

  let playerRef = useRef(null)

  let actions = useMemo(() => {
    return {
      play(episode) {
        console.log('Attempting to play episode:', episode)

        if (episode && episode.audio && episode.audio.src) {
          dispatch({ type: ActionKind.SET_META, payload: episode })

          if (
            playerRef.current &&
            playerRef.current.currentSrc !== episode.audio.src
          ) {
            let playbackRate = playerRef.current.playbackRate
            playerRef.current.src = episode.audio.src
            playerRef.current.load()
            playerRef.current.pause()
            playerRef.current.playbackRate = playbackRate
            playerRef.current.currentTime = 0
          }

          playerRef.current?.play()
        } else {
          console.error('Episode audio source is undefined')
        }
      },
      pause() {
        playerRef.current?.pause()
      },
      toggle(episode) {
        this.isPlaying(episode) ? actions.pause() : actions.play(episode)
      },
      seekBy(amount) {
        if (playerRef.current) {
          playerRef.current.currentTime += amount
        }
      },
      seek(time) {
        if (playerRef.current) {
          playerRef.current.currentTime = time
        }
      },
      playbackRate(rate) {
        if (playerRef.current) {
          playerRef.current.playbackRate = rate
        }
      },
      toggleMute() {
        dispatch({ type: ActionKind.TOGGLE_MUTE })
      },
      isPlaying(episode) {
        return episode && episode.audio && episode.audio.src
          ? state.playing && playerRef.current?.currentSrc === episode.audio.src
          : false
      },
      playNext() {
        if (state.currentEpisodeIndex < state.episodes.length - 1) {
          const nextIndex = state.currentEpisodeIndex + 1
          const nextEpisode = state.episodes[nextIndex]

          if (nextEpisode && nextEpisode.audio && nextEpisode.audio.src) {
            dispatch({
              type: ActionKind.SET_CURRENT_EPISODE_INDEX,
              payload: nextIndex,
            })
            actions.play(nextEpisode)
          } else {
            console.error('Next episode audio source is undefined')
          }
        }
      },
      playPrevious() {
        if (state.currentEpisodeIndex > 0) {
          const prevIndex = state.currentEpisodeIndex - 1
          const prevEpisode = state.episodes[prevIndex]

          if (prevEpisode && prevEpisode.audio && prevEpisode.audio.src) {
            dispatch({
              type: ActionKind.SET_CURRENT_EPISODE_INDEX,
              payload: prevIndex,
            })
            actions.play(prevEpisode)
          } else {
            console.error('Previous episode audio source is undefined')
          }
        }
      },
    }
  }, [state, dispatch])

  let api = useMemo(() => ({ ...state, ...actions }), [state, actions])

  return (
    <>
      <AudioPlayerContext.Provider value={api}>
        {children}
      </AudioPlayerContext.Provider>
      <audio
        ref={playerRef}
        onPlay={() => dispatch({ type: ActionKind.PLAY })}
        onPause={() => dispatch({ type: ActionKind.PAUSE })}
        onTimeUpdate={(event) => {
          dispatch({
            type: ActionKind.SET_CURRENT_TIME,
            payload: Math.floor(event.currentTarget.currentTime),
          })
        }}
        onDurationChange={(event) => {
          dispatch({
            type: ActionKind.SET_DURATION,
            payload: Math.floor(event.currentTarget.duration),
          })
        }}
        muted={state.muted}
      />
    </>
  )
}

export function useAudioPlayer(episode) {
  const player = useContext(AudioPlayerContext)

  return useMemo(
    () => ({
      ...player,
      play() {
        console.log('Playing episode:', episode) // Debugging log
        player.play(episode || player.episode) // Use current episode if none is passed
      },
      toggle() {
        console.log('Toggling play/pause for episode:', episode) // Debugging log
        player.toggle(episode || player.episode) // Use current episode if none is passed
      },
      get playing() {
        return player.isPlaying(episode || player.episode)
      },
    }),
    [player, episode]
  )
}
